export enum Status {
  RECEBIDO = 1,
  CABECALHO_PENDENTE = 2,
  CABECALHO_INVALIDO = 3,
  PROCESSAR_LINHAS = 4,
  PRONTO_PARA_VALIDAR = 5,
  VALIDANDO = 6,
  INVALIDO = 7,
  CANCELAR_PROCESSAMENTO = 8,
  PRONTO_PROCESSAR = 9,
  PROCESSANDO = 10,
  PROCESSADO_OK = 11,
  PROCESSAMENTO_FALHOU = 12
}

export enum StatusProcessamento {
  PROCESSANDO = 'PROCESSANDO',
  CORRIGIR_CABECALHO = 'CORRIGIR_CABECALHO',
  CORRIGIR_DADOS = 'CORRIGIR_DADOS',
  CANCELADA = 'CANCELADA',
  CONCLUIDO_COM_FALHAS = 'CONCLUIDO_COM_FALHAS',
  CONCLUIDO = 'CONCLUIDO'
}
